import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import VersionBadge from "@/components/VersionBadge";
import GhostWidget from "@/components/GhostWidget";
import HomePage from "@/pages/HomePage";
import ApplyPage from "@/pages/ApplyPage";
import ApplyConsumerPage from "@/pages/ApplyConsumerPage";
import ApplyPartnerPage from "@/pages/ApplyPartnerPage";
import ACHPage from "@/pages/ACHPage";
import ACHConsumerPage from "@/pages/ACHConsumerPage";
import BecomePartnerPage from "@/pages/BecomePartnerPage";
import PartnerLoginPage from "@/pages/PartnerLoginPage";
import FAQPage from "@/pages/FAQPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import PaymentPage from "@/pages/PaymentPage";
import BusinessFundingPage from "@/pages/BusinessFundingPage";

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/apply" element={<ApplyPage />} />
            <Route path="/apply-consumer" element={<ApplyConsumerPage />} />
            <Route path="/apply-partner" element={<ApplyPartnerPage />} />
            <Route path="/ach" element={<ACHPage />} />
            <Route path="/ach-consumer" element={<ACHConsumerPage />} />
            <Route path="/payment" element={<PaymentPage />} />
            <Route path="/business-funding" element={<BusinessFundingPage />} />
            <Route path="/become-partner" element={<BecomePartnerPage />} />
            <Route path="/partner-login" element={<PartnerLoginPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
          </Routes>
        </main>
        <Footer />
        <VersionBadge />
        <GhostWidget />
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
